(function () {
    window.LBSApp = window.LBSApp || {};
    window.LBSApp.Components = window.LBSApp.Components || {};
    
    window.LBSApp.Components.DatumTicketNumber = function (element, type, ticketNumberFormInputSelector) {
        validTypes = ['DATUM_YYMMDD', 'DATUM_YYMM']
        if (!validTypes.includes(type)) {
            throw new Error("Invlaid datum ticker number type: " + type);
        }

        const yearEl = element.querySelector('.select-date-lottery-number-container #year');
        const monthEl = element.querySelector('.select-date-lottery-number-container #month');
        const dayEl = element.querySelector('.select-date-lottery-number-container #day');
        const displayNumberEl = element.querySelector('.select-date-lottery-number-container .number')
        const errorContainerEl = element.querySelector('.date-ticket-number-error-container');
        const errorMissingPartsEl = element.querySelector('.missing-parts-error-message');
        const ticketNumberFormInputEl = !!ticketNumberFormInputSelector ? document.querySelector(ticketNumberFormInputSelector) : null;
        const includeDay = type === 'DATUM_YYMMDD';

        showErrorContainer = false;
        
        function initEventListeners() {
            yearEl.addEventListener('change', setTicketNumber);
            monthEl.addEventListener('change', setTicketNumber);
            if (includeDay) {
                dayEl.addEventListener('change', setTicketNumber);
            }
            // it is possible to trigger the validation from other components. This can be usefull if you want to run validation on form submit
            // trigger the validation with : document.dispatch(new Event('kombi.datumticketnumber.validate'))
            document.addEventListener('kombi.datumticketnumber.validate', validateAndShowAllErrors);
        }

        // initialise the selects based on the value in the form input.
        // needed when the page reloads
        function initStartValue() {
            if (ticketNumberFormInputEl) {
                const ticketNumber = ticketNumberFormInputEl.value;
                if (includeDay && ticketNumber && ticketNumber.length === 6) {
                    yearEl.value = ticketNumber.substring(0, 2);
                    monthEl.value = ticketNumber.substring(2, 4);
                    dayEl.value = ticketNumber.substring(4, 6);
                }
                else if (!includeDay && ticketNumber && ticketNumber.length === 4) {
                    yearEl.value = ticketNumber.substring(0, 2);
                    monthEl.value = ticketNumber.substring(2, 4);
                }
                validate();
            }
        }

        // returns the value from the select element
        function getValue(selectEl) {
            const hasValue = selectEl && !!selectEl.value && selectEl.value != '0';
            if (hasValue) {
                return selectEl.value;
            }
            return null; 
        }

        // validates the select and adds css classes to the row element
        function validateSelect(selectEl) {
            var selectRowEl = selectEl.parentElement;
            const value = getValue(selectEl);
            if (!!value) {
                selectRowEl.classList.add('is-valid')
                selectRowEl.classList.remove('is-invalid')
            }
            else {
                selectRowEl.classList.add('is-invalid')
                selectRowEl.classList.remove('is-valid')
            }
            return !!value;
        }

        // Validates all selects
        function validate() {
            var missingParts = [];
            var day = includeDay ? validateSelect(dayEl) : true;
            var month = validateSelect(monthEl);
            var year = validateSelect(yearEl);
            if (!year) { 
                missingParts.push("år");
            } 
            if (!month) {
                missingParts.push("månad");
            }
            if (includeDay && !day) {
                missingParts.push("dag");
            }

            var isValidNumber = missingParts.length === 0;
            if (showErrorContainer && !isValidNumber) {
                errorMissingPartsEl.innerHTML = missingParts.join(", ");
                errorContainerEl.classList.remove('hide');
            }
            else {
                errorMissingPartsEl.innerHTML = '';
                errorContainerEl.classList.add('hide');
            }

            return isValidNumber;
        }

        // validates and shows the error text message. 
        // will also show the error message container
        function validateAndShowAllErrors() {
            if (includeDay) {
                dayEl.parentElement.classList.add('is-dirty');
            }
            monthEl.parentElement.classList.add('is-dirty');
            yearEl.parentElement.classList.add('is-dirty');
            showErrorContainer = true;
            validate();
        }

        function createOption(value, text) {
            const option = document.createElement("option");
            option.value = value;
            option.textContent = text;
            return option;
        }

        function getDaysInMonth(year, month) {
            if (month === 2) {
                // February has 28 days in a common year, 29 in a leap year
                const isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
                return isLeapYear ? 29 : 28;
            } else {
                // All other months have either 30 or 31 days
                const thirtyOneDayMonths = [1, 3, 5, 7, 8, 10, 12];
                return thirtyOneDayMonths.includes(month) ? 31 : 30;
            }
        }

        // updates the number of days available in the day dropdown based on year and month
        function updateDayOptions(currentDayValue) {
            var month = getValue(monthEl);
            var year = getValue(yearEl);
            let daysInMonth = 31;
            if (year && month) {
                daysInMonth = getDaysInMonth(parseInt(year), parseInt(month)) + 1;
            }
            dayEl.innerHTML = '';
            dayEl.appendChild(createOption('0', 'Ej vald'));
            for (let i = 1; i < daysInMonth; i++) {
                const val = i.toString().padStart(2, '0');
                dayEl.appendChild(createOption(val, val));
            }

            // the value is reset when the options as removed and added
            // this will restore the value if possible
            if (currentDayValue && currentDayValue <= daysInMonth) {
                dayEl.value = currentDayValue;
            }
            else {
                dayEl.value = '0';
            }

            // get selected value again. If 31 was selected and the february, the select should be reseted.
            return getValue(dayEl);
        }

        function setTicketNumber(evt) {
            evt.target.parentElement.classList.add('is-dirty');
            let day = getValue(dayEl);
            const month = getValue(monthEl);
            const year = getValue(yearEl);

            if (includeDay) {
                day = updateDayOptions(day);
            }
            validate();

            if (ticketNumberFormInputEl) {
                var isValidNumber = validate();
                if (isValidNumber) {
                    var datumLott = year + '' + month + '' + (includeDay ? day : '');
                    ticketNumberFormInputEl.value = datumLott;
                }
                else {
                    ticketNumberFormInputEl.value = null;
                }
            }
            var datumLott = (year || '--') + "" + (month || '--') + "" + (includeDay ? (day || '--') : '');
            displayNumberEl.innerHTML = datumLott;
        }

        initStartValue();
        initEventListeners();
    }
})()